import React from 'react'
import styled, { keyframes } from 'styled-components'

import { COLORS } from '~/common/globalStyles'

interface LoaderContainerProps {
  centered?: boolean
}

const LoaderContainer = styled.div<LoaderContainerProps>`
  text-align: center;
  width: ${({ centered }) => (centered ? '100%' : 'auto')};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const LoaderSpinner = styled.div`
  position: relative;
  display: inline-block;
  width: 34px;
  height: 6px;
  text-align: center;
`

const LoaderSpinnerDots = styled.div`
  display: flex;
  box-pack: distribute;
  justify-content: space-around;
`

const pulse = keyframes`
	0%,
  100%,
  80% {
    opacity: 0;
    transform: scale(.8);
  }

  40% {
    opacity: 1;
    transform: scale(1);
  }
`

const LoaderSpinnerDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ color, theme }) =>
    color === COLORS.blue ? (theme?.palette?.current ?? COLORS.blue) : color};
  animation: ${pulse} 1s infinite ease-in-out;
`

const Dot1 = styled(LoaderSpinnerDot)`
  animation-delay: -0.32s;
`

const Dot2 = styled(LoaderSpinnerDot)`
  animation-delay: -0.16s;
`

const Dot3 = styled(LoaderSpinnerDot)``

interface LoaderProps {
  color?: keyof typeof COLORS
  centered?: boolean
  style?: React.CSSProperties
  className?: string
}

const Loader: React.FC<LoaderProps> = ({
  color,
  centered,
  style,
  className,
}) => {
  return (
    <LoaderContainer
      data-testid="loader"
      centered={centered}
      style={style}
      className={className}
    >
      <LoaderSpinner>
        <LoaderSpinnerDots>
          <Dot1 color={color} />
          <Dot2 color={color} />
          <Dot3 color={color} />
        </LoaderSpinnerDots>
      </LoaderSpinner>
    </LoaderContainer>
  )
}

Loader.defaultProps = {
  color: COLORS.blue as keyof typeof COLORS,
}

export default Loader
